React           = require 'react'
Xrespond        = require('../scripts/xrespond')
MessageBusMixin = require '../mixins/message_bus'

module.exports = XrespondSource = React.createClass
  mixins: [ MessageBusMixin ]
  getInitialState: ->
    url: Xrespond.local.attr('url')
  handleSubmit: (e) ->
    e.preventDefault()
    source_value = @refs.source.value.trim()
    @publish 'sourceSubmit', @assert_prefix(source_value)

  assert_prefix: (url) ->
    if url.match(/^http/) or url == '' then url else 'https://' + url

  render: ->
    React.createElement("form", {"className": "source-url__wrap", "onSubmit": (@handleSubmit)},
      React.createElement("input", {"className": "text-input text-input--medium source-url__text-input", "defaultValue": (@state.url), "placeholder": "Enter URL", "ref": "source"}),
      React.createElement("button", {"className": "button button--medium button--primary source-url__button"}, "Load URL")
    )



// WEBPACK FOOTER //
// ./~/cjsx-loader!./app/js/components/source.cjsx